var map = {
	"./TVA.png": 6050,
	"./bad_hospital.jpg": 6251,
	"./bodybuilding.jpg": 7881,
	"./maths.jpg": 6256,
	"./olive.jpeg": 6653,
	"./prayer.jpeg": 8925,
	"./tunisia.jpeg": 8031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8245;